import { Component } from "@angular/core";
import { Global } from '../../globals'
import { AlertService, CryptoService, StorageServiceProvider } from '../../_services/services';
import { AppSettingsServiceProvider } from '../../_services/app-settings.service';
import { Settings } from "../../_models/settings/settings.model";
import { GatewayServiceProvider } from "../../_services/gateway.service";
import { Title } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { StorageKeys } from "src/app/_constants";
import { Router } from "@angular/router";
import { MaterialModule } from "src/app/material.module";
import { SharedModule } from "src/app/shared.module";
import { LoginComponent } from "../login/login.component";
import { LoadingService } from "src/app/_services/loading.service";

@Component({
    templateUrl: 'app-settings.component.html',
    standalone: true, // Required for Angular 18's new standalone components
    imports: [
        SharedModule,
        MaterialModule,
        LoginComponent
    ]
})

export class AppSettingsComponent {
    settings: Settings;
    ctdText: string;
    datasetsList = [];
    selectedDataset: any;
    alreadySeletecdDataset: any;
    hide = true;
    constructor(

        private router: Router,
        public globals: Global,
        private appService: AppSettingsServiceProvider,
        private alertService: AlertService,
        private gateway: GatewayServiceProvider,
        private titleService: Title,
        private crypt: CryptoService,
        private storage: StorageServiceProvider,
        private blockUI: LoadingService
    ) {
        // this.titleService.setTitle("App Settings");
        this.ctdText = window.location.href.includes('salesctd.agris.com') ? " - CTD" : "";
        this.settings = this.storage.get(StorageKeys.Settings) || new Settings();
        this.settings.appName = this.settings.appName == undefined ? 'AgrisSales' : this.settings.appName;
        this.settings.agentEmail = '';//cpi@culturatech.com
        this.settings.agentPassword = '';//password1
        this.alreadySeletecdDataset = localStorage.getItem('dataSet');
    }
    connect() {
        this.alertService.clear();
        this.blockUI.start();
        // let EncrptedPass=this.crypt.encryptString(this.settings.password);
        this.settings.agentEncryptedPassword = this.crypt.encryptString(this.settings.agentPassword);
        delete this.settings.agentPassword;
        this.appService.GetActivation(this.settings.agentEmail, this.settings.agentEncryptedPassword, this.settings.appName).then((data) => {

            localStorage.setItem('AgentId', data.MoreInfo.AgentId);
            localStorage.setItem('settings', JSON.stringify(this.settings));

            let localStorageItem = JSON.parse(localStorage.getItem('settings'));
            localStorageItem.locationCode = '';
            localStorage.setItem('settings', JSON.stringify(localStorageItem));

            this.appService.GetAgentSessionId(data.MoreInfo.UserName, data.MoreInfo.Password, () => {
                this.settings = this.storage.get(StorageKeys.Settings);;
                this.settings.agentUsername = data.MoreInfo.UserName;
                this.settings.agentEncryptedPassword = data.MoreInfo.Password;
                localStorage.setItem('settings', JSON.stringify(this.settings));
                this.gateway.getLiveDatasets((dataSets) => {
                    console.log(dataSets);
                    this.datasetsList = dataSets;
                    this.deSelectDataset();
                    this.blockUI.stop();
                }, (error) => {
                    console.log(error);
                    Sentry.captureMessage("Handled Error: " + JSON.stringify(error));
                    const msg = (error && error.error && error.error.Message) ? error.error.Message : (error && error.Message) ? error.Message : (typeof error === 'string' ? error : JSON.stringify(error));
                    this.alertService.error(msg);
                    this.blockUI.stop();
                });
                this.gateway.getAgentType((agentType) => {
                    console.log(agentType);
                    localStorage.setItem("AgentType", agentType.AgentType);
                    this.blockUI.stop();
                }, (error) => {
                    console.log(error);
                    Sentry.captureMessage("Handled Error: " + JSON.stringify(error));
                    const msg = (error && error.error && error.error.Message) ? error.error.Message : (error && error.Message) ? error.Message : (typeof error === 'string' ? error : JSON.stringify(error));
                    this.alertService.error(msg);
                    this.blockUI.stop();
                });
            }, (error) => {
                console.log(error);
                Sentry.captureMessage("Handled Error: " + JSON.stringify(error));
                const msg = (error && error.error && error.error.Message) ? error.error.Message : (error && error.Message) ? error.Message : (typeof error === 'string' ? error : JSON.stringify(error));
                this.alertService.error(error.Code == 401 ? 'Sorry, the app is unable to connect to the agent. Please try again or contact your administrator.' : msg);
            });
        }).catch(error => {
            Sentry.captureMessage("Handled Error: " + JSON.stringify(error));
            switch (error.Code) {
                case 503:
                    this.alertService.error("Sorry, the app is unable to connect to the server. Please try again or contact your administrator.");
                    this.blockUI.stop();
                    break;
                case 403:
                    // this.alertService.error("Please provide a correct email or password.");
                    const msg403 = (error && error.error && error.error.Message) ? error.error.Message : (error && error.Message) ? error.Message : (typeof error === 'string' ? error : JSON.stringify(error));
                    this.alertService.error(msg403);
                    this.blockUI.stop();
                    break;
                default:
                    const msgDefault = (error && error.error && error.error.Message) ? error.error.Message : (error && error.Message) ? error.Message : (typeof error === 'string' ? error : JSON.stringify(error));
                    this.alertService.error(msgDefault);
                    this.blockUI.stop();
                    break;
            }
        });
    }
    deSelectDataset() {
        this.selectedDataset = null;
    }
    selectDataset(dataset) {
        // this.titleService.setTitle("App Settings - Select Dataset");
        this.selectedDataset = dataset;
        localStorage.setItem('dataSet', JSON.stringify(dataset));
        let settings = this.storage.get(StorageKeys.Settings);;;
        let sentrytag = settings.agentEmail + ' - ' + dataset.TenantName;
        Sentry.getCurrentScope().setTag("tenant", sentrytag);
        this.router.navigate(['/login']);

    }
    exitTestingMode() {
        window.open('https://sales.agris.com/appsettings', '_self', '');
    }
}